import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

/**
 * Loads Google Analytics (gtag.js) using the Measurement ID stored in site settings.
 * Renders nothing visually; injects two <script> tags into <head> when an ID is set.
 * Also tracks SPA page_view changes on route navigation.
 */
const GA_SCRIPT_ID = "ga-loader-script";
const GA_INLINE_ID = "ga-inline-script";

export const GoogleAnalytics = () => {
    const location = useLocation();

    useEffect(() => {
        let cancelled = false;
        api.get("/settings")
            .then((r) => {
                if (cancelled) return;
                const id = (r.data?.google_analytics_id || "").trim();
                if (!id) return;
                if (document.getElementById(GA_SCRIPT_ID)) return;

                const loader = document.createElement("script");
                loader.id = GA_SCRIPT_ID;
                loader.async = true;
                loader.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(id)}`;
                document.head.appendChild(loader);

                const inline = document.createElement("script");
                inline.id = GA_INLINE_ID;
                inline.text = `window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
window.gtag = gtag;
gtag('js', new Date());
gtag('config', '${id}', { anonymize_ip: true });`;
                document.head.appendChild(inline);
            })
            .catch(() => {});
        return () => {
            cancelled = true;
        };
    }, []);

    // SPA page_view on route change
    useEffect(() => {
        if (typeof window === "undefined" || typeof window.gtag !== "function") return;
        window.gtag("event", "page_view", {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title,
        });
    }, [location.pathname, location.search]);

    return null;
};

export default GoogleAnalytics;
